(function() {
  if (window.innerWidth < 1200) return;

  let previewContainer = null;

  function getGallery() {
    return document.querySelector('.wt-product__gallery');
  }

  function getGalleryRect() {
    const gallery = getGallery();
    if (!gallery) return null;
    const galleryDataEl = gallery.querySelector('[data-gallery]');
    return galleryDataEl ? galleryDataEl.getBoundingClientRect() : gallery.getBoundingClientRect();
  }

  function initVariantHoverPreview() {
    const variantOptions = document.querySelector('variant-options');
    if (!variantOptions) return;

    const variantData = JSON.parse(variantOptions.querySelector('[type="application/json"]')?.textContent || '[]');
    if (variantData.length === 0) return;

    if (!previewContainer) {
      previewContainer = document.createElement('div');
      previewContainer.className = 'variant-image-preview';
      document.body.appendChild(previewContainer);
    }

    variantData.forEach(v => {
      if (v.featured_image) {
        const img = new Image();
        img.src = v.featured_image.src;
      }
    });

    const allOptions = variantOptions.querySelectorAll('.wt-product__option');
    let sizeOption = null;
    let sizeOptionIndex = -1;

    allOptions.forEach((opt, index) => {
      const label = opt.querySelector('.wt-product__option__title .label');
      if (label && label.textContent.trim().toLowerCase().includes('rozmiar')) {
        sizeOption = opt;
        sizeOptionIndex = index;
      }
    });

    if (!sizeOption) return;

    const sizeInputs = sizeOption.querySelectorAll('input[type="radio"]');

    function getCurrentOptions() {
      const options = [];
      const currentOptions = document.querySelectorAll('variant-options .wt-product__option');
      currentOptions.forEach(opt => {
        const checked = opt.querySelector('input[type="radio"]:checked');
        if (checked) {
          options.push(checked.value);
        }
      });
      return options;
    }

    function findVariant(options) {
      return variantData.find(v => {
        return options.every((opt, idx) => v.options[idx] === opt);
      });
    }

    function updatePreviewPosition() {
      if (!previewContainer || !previewContainer.classList.contains('is-visible')) return;
      const rect = getGalleryRect();
      if (rect) {
        previewContainer.style.top = rect.top + 'px';
        previewContainer.style.left = rect.left + 'px';
      }
    }

    const sizeValueDisplay = sizeOption.querySelector('.wt-product__option__title .value');

    function updateSizeValueDisplay(wymiary) {
      if (sizeValueDisplay && wymiary) {
        sizeValueDisplay.innerHTML = wymiary;
      }
    }

    function getSelectedSizeWymiary() {
      const checkedInput = sizeOption.querySelector('input[type="radio"]:checked');
      return checkedInput?.dataset?.wymiary || checkedInput?.value || '';
    }

    sizeInputs.forEach(input => {
      const listItem = input.closest('li');
      if (!listItem) return;

      if (listItem._variantHoverInitialized) return;
      listItem._variantHoverInitialized = true;

      listItem.addEventListener('mouseenter', function() {
        const hoveredWymiary = input.dataset.wymiary || input.value;
        updateSizeValueDisplay(hoveredWymiary);

        const currentOptions = getCurrentOptions();
        currentOptions[sizeOptionIndex] = input.value;

        const matchingVariant = findVariant(currentOptions);

        // notify other UI that we're previewing this variant (quote meta, etc.)
        if (matchingVariant) {
          document.dispatchEvent(new CustomEvent('variantPreviewShow', { detail: { variantId: matchingVariant.id } }));
        }

        if (matchingVariant && matchingVariant.featured_image) {
          const rect = getGalleryRect();
          if (!rect || rect.width === 0) return;

          previewContainer.innerHTML = `<img src="${matchingVariant.featured_image.src}" alt="${matchingVariant.title}">`;

          previewContainer.style.top = rect.top + 'px';
          previewContainer.style.left = rect.left + 'px';
          previewContainer.style.width = rect.width + 'px';
          previewContainer.style.height = 'auto';
          previewContainer.style.maxHeight = rect.height + 'px';

          previewContainer.classList.add('is-visible');
        }
      });

      listItem.addEventListener('mouseleave', function() {
        // notify other UI to revert preview
        document.dispatchEvent(new CustomEvent('variantPreviewHide'));
        previewContainer.classList.remove('is-visible');
        updateSizeValueDisplay(getSelectedSizeWymiary());
      });
    });

    window.removeEventListener('scroll', updatePreviewPosition);
    window.addEventListener('scroll', updatePreviewPosition);
  }

  function waitForGalleryAndInit() {
    const checkGallery = () => {
      const rect = getGalleryRect();
      if (rect && rect.width > 0) {
        initVariantHoverPreview();
      } else {
        requestAnimationFrame(checkGallery);
      }
    };
    checkGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForGalleryAndInit);
  } else {
    waitForGalleryAndInit();
  }

  document.addEventListener('gallery:updated', () => {
    setTimeout(waitForGalleryAndInit, 100);
  });

  document.addEventListener('variantChangeEnd', () => {
    setTimeout(waitForGalleryAndInit, 300);
  });
})();
